import React from 'react';

const Home_Top = () => {
  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '200px' }}>
          <div className="container d-flex justify-content-center align-items-center">
      <div className="text-center mt-4">
        <h1>WelCome To travel Bae</h1>
        <span>Explore Exited Destination With Us</span>
      </div>
    </div>
    </div>
  
  );
};

export default Home_Top;
